import { Extension } from '@tiptap/core';
import debounce from 'lodash/debounce';
import type { Editor } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      originalState: {
         updateSavedContent: () => ReturnType;
      };
   }
}

interface OriginalStateOptions {
   debounce?: number;
   handleModified?: (modified: boolean) => void;
}

const createDebouncedCheck = (wait: number, callback: (modified: boolean) => void) =>
   debounce(
      (editor: Editor) => {
         const modified = !editor.state.doc.eq(editor.storage.originalState.savedContent);
         callback(modified);
         editor.storage.originalState.hasUnsavedChanges = modified;
      },
      wait,
      { leading: true }
   );

export const OriginalState = Extension.create<OriginalStateOptions, any>({
   name: 'originalState',

   addOptions() {
      return {
         debounce: 500, // in ms
         handleModified: () => {},
      };
   },

   addCommands() {
      return {
         updateSavedContent:
            () =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.savedContent = this.editor.state.doc;
                  this.storage.hasUnsavedChanges = false;
               }
               return true;
            },
      };
   },

   onUpdate() {
      this.storage.checkModified(this.editor);
   },

   onCreate() {
      this.editor.commands.updateSavedContent();
      this.storage.checkModified = createDebouncedCheck(
         // @ts-expect-error TS(2345) FIXME: Argument of type 'number | undefined' is not assig... Remove this comment to see the full error message
         this.options.debounce,
         this.options.handleModified
      );
   },

   addStorage() {
      return {
         savedContent: null,
         hasUnsavedChanges: false,
         checkModified: () => {},
      };
   },
});
